import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Divider } from "@mui/material";
import { Close } from "@mui/icons-material";
import moment from "moment";
import { getImportantMaintenance } from "api";

const MaintenanceDialog = () => {
	const [open, setOpen] = useState(false);
	const [content, setContent] = useState("");

	const handleClose = () => {
		setOpen(false);
	};

	const handleDontShow = () => {
		const maintenanceNoticeExpirationTime = moment().add(1, "day").startOf("day").valueOf();
		localStorage.setItem("dontShowMaintenanceNotice", true);
		localStorage.setItem("maintenanceNoticeExpirationTime", maintenanceNoticeExpirationTime);
		handleClose();
	};

	const clearLocalStorageFlag = () => {
		localStorage.removeItem("dontShowMaintenanceNotice");
		localStorage.removeItem("maintenanceNoticeExpirationTime");
	};

	const getMaintenance = async () => {
		const dontShowMaintenanceNotice = localStorage.getItem("dontShowMaintenanceNotice");
		try {
			const { data } = await getImportantMaintenance();
			if (data.id) {
				if (!dontShowMaintenanceNotice) {
					setOpen(true);
					setContent(data.content);
				}
			} else {
				clearLocalStorageFlag();
			}
		} catch (err) {
			return false;
		}
	};

	useEffect(() => {
		// 过期的时间戳
		const maintenanceNoticeExpirationTime = localStorage.getItem("maintenanceNoticeExpirationTime");
		const nowTime = moment().valueOf();
		// 判断是否过期，过期清空flag
		if (maintenanceNoticeExpirationTime && nowTime > maintenanceNoticeExpirationTime) {
			clearLocalStorageFlag();
		}
		getMaintenance();
	}, []);

	return (
		<Dialog open={open} onClose={handleClose}>
			<DialogTitle sx={{ padding: "10px 24px", color: ({ palette }) => palette.primary.main }}>
				Scheduled System Maintenance
			</DialogTitle>
			<IconButton
				onClick={handleClose}
				sx={(theme) => ({
					position: "absolute",
					right: 8,
					top: 6,
					color: theme.palette.grey[500],
				})}
			>
				<Close />
			</IconButton>
			<Divider variant="middle" sx={{ borderWidth: "1px", borderColor: ({ palette }) => palette.primary.main }} />
			<DialogContent>
				<div dangerouslySetInnerHTML={{ __html: content }}></div>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleDontShow}>{`Don't show again today`}</Button>
				<Button variant="contained" onClick={handleClose}>
					OK
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default MaintenanceDialog;
